export const HOME_PAGE = "/";
export const INTAKE_PAGE = "/intake";
export const VISIT_PAGE = "/visit/:caseId/:visitId";
export const LOGIN_PAGE = "/login";
export const SIGNUP_PAGE = "/signup";
export const CASES_PAGE = "/cases/:status";
export const CASEOVERVIEW_PAGE = "/caseoverview/:id";

// TODO: Delete these
export const EDIT_TEAM_PAGE = "/edit-team";

export const DISPLAY_ENTITY_PAGE = "/entity";

export const CREATE_ENTITY_PAGE = "/entity/create";

export const UPDATE_ENTITY_PAGE = "/entity/update";

export const HOOKS_PAGE = "/hooks";

export const DEFAULT_PAGE = "/default";

export const TEMPLATE_PAGE = "/template";
